import React from 'react';
import { Table } from 'antd';
import 'antd/dist/antd.css';

const LastFedral = ({ columns, dataSource }) => {

  return (
    <>
      <p style={{ fontWeight: 'bold', fontSize: '18px' }}>Last Federal Inspection</p>
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        scroll={{ x: 'max-content' }}
      />
    </>
  );
};

export default LastFedral;
